<script>
  import {onMount, afterUpdate, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import {media} from 'svelte-match-media'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import AnimatedBlock from '../components/AnimatedBlock.svelte'
  import Accordion from '../components/Accordion.svelte'
  import LaptopVideo from '../components/LaptopVideo.svelte'

  let st, accordionsEl;
  const accordionsData = [
    {
      open: false,
      id: 'omniscope_q1',
      videoMobile: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105923/VerizonMediaATV/Where_can_I_find_my_audience_on_CTV_supply-480_engiel.mp4',
      videoDesktop: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105924/VerizonMediaATV/Where_can_I_find_my_audience_on_CTV_supply-720_l5cznz.mp4',
      posterMobile: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_540,q_auto/v1616161981/VerizonMediaATV/Where_can_I_find_my_audience_on_CTV_supply_tn8hmn.jpg',
      posterDesktop: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_1080,q_auto/v1616161981/VerizonMediaATV/Where_can_I_find_my_audience_on_CTV_supply_tn8hmn.jpg',
      title: 'Where can I find my audience on CTV supply?',
      answer: 'Layer numerous targeting restrictions to find the most efficient path to your consumer.'
    },
    {
      open: false,
      id: 'omniscope_q2',
      videoMobile: 'https://res.cloudinary.com/tanka-design/video/upload/v1616088339/VerizonMediaATV/Should_I_buy_a_specific_CTV_publisher-480_bzzp19.mp4',
      videoDesktop: 'https://res.cloudinary.com/tanka-design/video/upload/v1616088581/VerizonMediaATV/Should_I_buy_a_specific_CTV_publisher-720_fw0hpi.mp4',
      posterMobile: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_540,q_auto/v1616161981/VerizonMediaATV/Should_I_buy_a_specific_CTV_publisher_tgxasb.jpg',
      posterDesktop: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_1080,q_auto/v1616161981/VerizonMediaATV/Should_I_buy_a_specific_CTV_publisher_tgxasb.jpg',
      title: 'Should I buy a specific CTV  publisher?',
      answer: 'Evaluate CTV apps or site lists for supply path optimization and efficient bidding.'
    },
    {
      open: false,
      id: 'omniscope_q3',
      videoMobile: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105924/VerizonMediaATV/What_s_the_right_budget_allocation-480_wmnyms.mp4',
      videoDesktop: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105924/VerizonMediaATV/What_s_the_right_budget_allocation-720_ds8f6w.mp4',
      posterMobile: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_540,q_auto/v1616161981/VerizonMediaATV/What_s_the_right_budget_allocation_glfvrv.jpg',
      posterDesktop: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_1080,q_auto/v1616161981/VerizonMediaATV/What_s_the_right_budget_allocation_glfvrv.jpg',
      title: 'What’s the right budget allocation?',
      answer: 'Quickly break down avails by CTV publisher and get a jump-start on appropriate line budgets.'
    },
    {
      open: false,
      id: 'omniscope_q4',
      videoMobile: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105923/VerizonMediaATV/What_supply_is_inside_my_CTV_Deal_ID-480_lneock.mp4',
      videoDesktop: 'https://res.cloudinary.com/tanka-design/video/upload/v1616105924/VerizonMediaATV/What_supply_is_inside_my_CTV_Deal_ID-720_t602vt.mp4',
      posterMobile: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_540,q_auto/v1616161981/VerizonMediaATV/What_supply_is_inside_my_CTV_Deal_ID_ygnenf.jpg',
      posterDesktop: 'https://res.cloudinary.com/tanka-design/image/upload/c_scale,h_1080,q_auto/v1616161981/VerizonMediaATV/What_supply_is_inside_my_CTV_Deal_ID_ygnenf.jpg',
      title: 'What supply is inside my CTV Deal ID?',
      answer: 'Understand the top publishers and geos included in a Deal ID.'
    }
  ]

  $: selectedAccordion = accordionsData.filter(acc => acc.open)[0]

  onMount(() => {
    st = ScrollTrigger.create({
      trigger: accordionsEl,
      start: 'top 70%+=100',
      onEnter: () => {
        accordionsData[0].open = true
        accordionsData = accordionsData
        st?.kill()
      }
    })
  })

  onDestroy(() => {
    st?.kill()
  })

  function onAccordionToggle (accordion) {
    accordionsData.forEach((acc, index) => {
      if(acc.title === accordion.title) {
        acc.open = !acc.open
      } else {
        acc.open = false
      }
    })
    accordionsData = accordionsData
  }
</script>
<section class="part4">
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle class="medium">Navigate a complex supply landscape with Omniscope.</AnimatedTitle>
      <AnimatedBlock><p class="subtitle">As viewer options expand across CTV and OTT supply, omniscope gives you a detailed understanding of what supply is available given your targeting parameters.</p></AnimatedBlock>
    </div>
  </div>
  <div class="rgrid-md-1-2">
    {#if $media.desktop}
      <div class="col">
        <LaptopVideo animated={true} src={selectedAccordion ? selectedAccordion.videoDesktop : ''} poster={selectedAccordion ? selectedAccordion.posterDesktop : accordionsData[0].posterDesktop} />
      </div>
    {/if}
    <div class="col">
      <AnimatedTitle size={2} class="title2">Get the answers to these questions <span class="nowrap">(and more)</span> with Omniscope:</AnimatedTitle>
      <div class="accordions" bind:this={accordionsEl}>
        {#each accordionsData as accordion, i (accordion.id)}
          <Accordion id={accordion.id} title={accordion.title} open={accordion.open} small={true} groupMode={true} groupTriggerEl={accordionsEl} index={i} on:toggle={event => onAccordionToggle(accordion)}>
            <p class="answer">{accordion.answer}</p>
            {#if $media.mobile}
            <LaptopVideo animated={true} src={accordion.open ? accordion.videoMobile : ''} poster={accordion.posterMobile} />
            {/if}
          </Accordion>
        {/each}
      </div>
    </div>
  </div>
</section>

<style>
  section :global(.subtitle) {
    margin: 2.25rem 0 6rem;
  }
  section :global(.title2) {
    margin-bottom: 2.5rem;
    font-weight: 500;
  }
  .answer {
    margin: 0 0 2rem;
  }
  .accordions :global(.accordion:not(:last-child)) {
    border-bottom-width: 0;
  }
</style>